/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { message, Modal } from "antd";
import { MessageType } from "antd/lib/message";

import config from "../config";
import { intl } from "../containers/app";

const { warning } = Modal;

/**
 * zavolá message.success z antd
 * @param userMessage zprava pro uživatele
 * @param duration doba trvání zobrazeni
 */
export const success = (userMessage: string, duration?: number): MessageType =>
  message.success(userMessage, duration || config.MESSAGE_DURATION);

/**
 * zavolá message.error z antd
 * @param userMessage zprava pro uživatele
 * @param duration doba trvání zobrazeni
 */
export const error = (userMessage: string, duration?: number): MessageType =>
  message.error(userMessage, duration || config.MESSAGE_DURATION);

/**
 * zavolá message.warn z antd
 * @param userMessage zprava pro uživatele
 * @param duration doba trvání zobrazeni
 */
export const warn = (userMessage: string, duration?: number): MessageType =>
  message.warn(userMessage, duration || config.MESSAGE_DURATION);

/**
 * zobrazí vyskakovací okno se zprávou
 * @param userMessage zpráva pro uživatele
 */
export const warningModal = (userMessage: string): any =>
  warning({
    title: intl.formatMessage({
      id: "messages.warning",
      defaultMessage: "Upozornění",
    }),
    content:
      userMessage ||
      intl.formatMessage({
        id: "messages.error",
        defaultMessage: "Při odesílání dat nastala chyba!",
      }),
  });
